/* global bocAmchart */

/**
 * Array of the ids for the amcharts to debug e.g. 'amchart1' etc. for local debugging
 * @type {[string]}
 */
bocAmchart.bocDebugIds = [];

if (!window.hasOwnProperty('jsErrors')) {
    jsErrors = [];
    window.onerror = function(error, url, line) {
        jsErrors.push(error + ". Line: " + line);
    };
}

/**
 * Check if this request should be debug output to console based on shortcode or above list
 * @param {AMConfig} chartSettings The chart options
 * @returns {boolean} should it debug?
 */
bocAmchart.debug = function (chartSettings) {
    var fromShortcode = chartSettings.hasOwnProperty("bocSettings")
        && chartSettings.bocSettings.hasOwnProperty("args")
        && chartSettings.bocSettings.args.debug === "true";

    var fromAbove = chartSettings.hasOwnProperty("bocSettings")
        && bocAmchart.bocDebugIds.indexOf(chartSettings.bocSettings.id) > -1;

    return fromShortcode || fromAbove;
};

/**
 * Helper function to make a clone of the object to avoid getting evergreen console output
 * @param {AMConfig} arg any object (probably AMCharts related)
 * @returns {object} clone with recursive object replaced by strings
 */
bocAmchart.debugClone = function (arg) {
    var lastKey = '';
    var recursiveKeys = [
        "serialDataItem",
        "chart",
        "D",
        "scope",
        "valueAxis",
        "data",
        "graph",
        "dItem",
        "graphDataItem",
        "object"
    ];
    try {
        return JSON.parse(
            JSON.stringify(
                arg,
                function (key, value) {
                    if (recursiveKeys.indexOf(key) > -1 && typeof value === 'object') {
                        return "Reference to '" + key + "' object";
                    } else {
                        lastKey = key;
                        return value;
                    }
                }
            )
        );
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
    // eslint-disable-next-line no-console
    console.log("Failed to clone the object, recursive key: " + lastKey);
    return arg;
};
